/**
 * Checks for booth name based on route
 * @returns {string} - base path
 */
export function getBasePath(): string {
    const paths: string[] = location.pathname.split('/').splice(1, 1);
    const basePath: string = (paths && paths[0]) || 'houdini'; // defaults to 'houdini'
    return '/' + basePath;
}
